var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ToolbarWithBackAndEditButtons, ToolbarWithBackButton, } from '../../common/Toolbar';
import { useRouter } from '../../../context/router-context';
import Loading from '../../common/Loading';
import SecondaryToolbarTitle from '../../common/SecondaryToolbarTitle';
import { getDisplayName } from '../../../utils/utils';
import { H5 } from '../../common/typography';
import DraftShareCertificate from './DraftShareCertificate';
import IssuedShareCertificate from './IssuedShareCertificate';
import CanceledShareCertificate from './CanceledShareCertificate';
import { useShareCertificateDetailsQuery } from '../../../__generated__/graphql';
function EditToolbar(props) {
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithBackAndEditButtons, __assign({ forwardTo: "update" }, { children: props.title }), void 0),
            _jsx(SecondaryToolbarTitle, { children: "Share Certificate" }, void 0)] }, void 0));
}
function BackToolbar(props) {
    return (_jsxs(_Fragment, { children: [_jsx(ToolbarWithBackButton, { children: props.title }, void 0),
            _jsx(SecondaryToolbarTitle, { children: "Share Certificate" }, void 0)] }, void 0));
}
export function ShareCertificateDetails(props) {
    return (_jsxs(_Fragment, { children: [_jsx(H5, { children: "Share class" }, void 0),
            _jsx("p", { children: props.shareCertificate.shareClass.name }, void 0),
            _jsx(H5, { children: "Sequence number" }, void 0),
            _jsx("p", { children: props.shareCertificate.sequenceNumber }, void 0),
            _jsx(H5, { children: "State" }, void 0),
            _jsx("p", __assign({ "data-test": "share-certificate-state" }, { children: props.shareCertificate.state }), void 0),
            _jsx(H5, { children: "Quantity" }, void 0),
            _jsx("p", __assign({ "data-test": "share-certificate-quantity" }, { children: props.shareCertificate.quantity }), void 0),
            _jsx(H5, { children: "Amount paid" }, void 0),
            _jsx("p", __assign({ "data-test": "share-certificate-amount-paid" }, { children: props.shareCertificate.amountPaid }), void 0),
            _jsx(H5, { children: "Holder" }, void 0),
            _jsx("p", __assign({ "data-test": "share-certificate-holder" }, { children: getDisplayName(props.shareCertificate) }), void 0),
            _jsx(H5, { children: "Issued at" }, void 0),
            _jsx("p", __assign({ "data-test": "issued-at" }, { children: props.shareCertificate.issuedAt || 'Date not provided' }), void 0),
            _jsx(H5, { children: "Remarks" }, void 0),
            _jsx("p", __assign({ "data-test": "share-certificate-remarks" }, { children: props.shareCertificate.remarks }), void 0)] }, void 0));
}
export default function ShareCertificate() {
    // Router
    var match = useRouter().match;
    var organizationId = match.params.organizationId;
    var shareCertificateId = match.params.shareCertificateId;
    // GraphQL query
    var _a = useShareCertificateDetailsQuery({
        variables: { shareCertificateId: shareCertificateId },
    }), data = _a.data, loading = _a.loading;
    var shareCertificate = data && data.shareCertificate;
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(EditToolbar, {}, void 0),
                _jsx(Loading, {}, void 0)] }, void 0));
    }
    if (!shareCertificate) {
        throw new Error('Share certificate query failed (share certificate not found)');
    }
    if (shareCertificate.state === 'DRAFT') {
        return (_jsxs(_Fragment, { children: [_jsx(EditToolbar, { title: shareCertificate.shareClass.organization.name }, void 0),
                _jsx(DraftShareCertificate, { organizationId: organizationId, shareCertificate: shareCertificate }, void 0)] }, void 0));
    }
    if (shareCertificate.state === 'ISSUED') {
        return (_jsxs(_Fragment, { children: [_jsx(BackToolbar, { title: shareCertificate.shareClass.organization.name }, void 0),
                _jsx(IssuedShareCertificate, { shareCertificate: shareCertificate }, void 0)] }, void 0));
    }
    // There are only three agreement states: draft, issued and canceled.
    // The following renders when shareCertificate.state === 'CANCELED'
    return (_jsxs(_Fragment, { children: [_jsx(BackToolbar, { title: shareCertificate.shareClass.organization.name }, void 0),
            _jsx(CanceledShareCertificate, { shareCertificate: shareCertificate }, void 0)] }, void 0));
}
//# sourceMappingURL=ShareCertificate.js.map